import type { FC } from 'react';
import { createContext, useContext } from 'react';
import { IServiceManagement } from '../types';
import { gotoSignInPage } from '../utils';

const ServiceContext = createContext<IServiceManagement | null>(null);

export const useService = (): IServiceManagement => {
  const service = useContext(ServiceContext);
  if (!service) {
    gotoSignInPage({
      shouldSavePreviousRoute: true,
    });
    throw new Error(
      'tried to consume context outside provider or service is not provided',
    );
  }
  return service;
};

export const ServiceProvider: FC<IProviderProps> = ({ service, children }) => {
  return (
    <ServiceContext.Provider value={service}>
      {children}
    </ServiceContext.Provider>
  );
};

interface IProviderProps {
  service: IServiceManagement;
}
